import { Component, OnInit,ElementRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { DataDBService } from '../servicios/data-db.service';
import { PeticionesService } from '../servicios/httpservice';
import { ExcelSerService } from '../servicios/excel-ser.service'

@Component({
  selector: 'app-transitos-generados',
  templateUrl: './transitos-generados.component.html',
  styleUrls: ['./transitos-generados.component.css']
})
export class TransitosGeneradosComponent implements OnInit {

  public arrayAlmacen:any;
  public arrayTransitos:any;
  public almacenOrigen:number=-1;
  public almacenDestino:number=-1;
  public almacenes:any;
  public spiner:boolean=false;
  public objetosAgrupadosPorLinea = {}
  public strBusqueda:string;
  public arrayAccesos:any=[];
  public tagName:any;
  public DatosUsuario:any;
  constructor(private _excelService: ExcelSerService,private router: Router, elem: ElementRef,private indexedDBService: DataDBService,private _httpService: PeticionesService) {
    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos=value?value:[];
      console.log(this.arrayAccesos[0])
      this.DatosUsuario = this.arrayAccesos[0]
      if (this.arrayAccesos.length > 0) {
        console.log(this.arrayAccesos[0]);
        this.DatosUsuario = this.arrayAccesos[0];
        this.fnobteneralmacenes();
        this.fnobtenertransitos();
      } else {
        this.router.navigate(['/login']);
      }
    });
   }

  ngOnInit(): void {
  }

  fnobteneralmacenes(){
    this.arrayAlmacen =[];
    this._httpService.getLogisticaPlaneador({strAccion:'getNombresAlmacen'}).subscribe(
      resultados => {
        this.arrayAlmacen =resultados;
        });  
  }
  
  fnobtenertransitos(){
    this.arrayTransitos =[];
    this._httpService.getLogisticaPlaneador({strAccion:'getSalidas'}).subscribe(
      resultados => {
        this.arrayTransitos =resultados;
        console.log(this.arrayTransitos);
        this.fndividir();
        });  
  }
   fndividir(){
     this.almacenes = [];
     this.almacenes = [];
  
  for (const objeto of this.arrayTransitos) {
    const existeEnAlmacenes = this.almacenes.some(
      (o) =>
        o.strAlm_Origen === objeto.strAlm_Origen &&
        o.strAlm_destino === objeto.strAlm_destino
    );
  
    if (!existeEnAlmacenes) {
      this.almacenes.push({
        strAlm_Origen: objeto.strAlm_Origen,
        strAlm_destino: objeto.strAlm_destino,
        strAlm_OrigenNombre: objeto.strAlm_OrigenNombre.replace("Almacen ", ""),
        strAlm_destinoNombre: objeto.strAlm_destinoNombre.replace("Almacen ", ""),
      });
    }
  }
  this.almacenes.forEach(element => {
    let arrayresult = this.arrayTransitos.filter(o => o.strAlm_Origen == element.strAlm_Origen && o.strAlm_destino == element.strAlm_destino );
    element.arrayresult=arrayresult;
  });
      console.log(this.almacenes)
      console.log(this.arrayTransitos)
  } 
  fnsumarCantidad(origen:number,destino:number):number{
    let filteredResults = this.almacenes.filter(o => o.strAlm_Origen === origen && o.strAlm_destino === destino);
    let suma = filteredResults[0].arrayresult.reduce((acumulador, registro) => acumulador + registro.dblCantidad, 0);
          return suma;
  }
  fnsumarVolumen(origen:number,destino:number):number{
    let filteredResults = this.almacenes.filter(o => o.strAlm_Origen === origen && o.strAlm_destino === destino);
    let suma = filteredResults[0].arrayresult.reduce((acumulador, registro) => acumulador + registro.dblVolumen, 0);
          return suma;
  }
  fnsumarVolumenT(origen:number,destino:number):number{
    let filteredResults = this.almacenes.filter(o => o.strAlm_Origen === origen && o.strAlm_destino === destino);
    let suma = filteredResults[0].arrayresult.reduce((acumulador, registro) => acumulador + (registro.dblCantidad*registro.dblVolumen), 0);
          return suma;
  }
  exportToExcel(){
    let array1 =[];
    if (this.almacenes) {
      const objetosConArrayResult = this.almacenes.filter(objeto => objeto.arrayresult !== undefined && objeto.arrayresult.length > 0);
      array1  = objetosConArrayResult;
      array1.sort((x, y) => x.strAlm_Origen - y.strAlm_Origen);
    }
    let array = [];
    array1.forEach(element => {
      element.arrayresult.forEach(ele => {
        let obj = {
          strAlm_OrigenNombre:element.strAlm_OrigenNombre || '',
          strAlm_Origen:element.strAlm_Origen || '',
          D:'->',
          strAlm_destino:element.strAlm_destino || '',
          strAlm_destinoNombre: ele.strAlm_destinoNombre || '',
          strArticulo: ele.strArticulo || '',
          strOpcion: ele.strOpcion || '', 
          strUnidad: ele.strUnidad || '',
          dblCantidad: ele.dblCantidad || '',
          dblVolumen: ele.dblVolumen || ''/* ,
          dblPeso: ele.dblPeso || '' */
        };
        array.push(obj) 
     
      });  
    /*   let obj2 = {
        strAlm_OrigenNombre: '',
        strAlm_destinoNombre: '',
        strArticulo:  '',
        strOpcion: '', 
        strUnidad:'',
        dblCantidad: '',
        dblVolumen:  '',
        dblPeso:  ''
      };
      array.push(obj2)  */
  
    });
   /*  let obj3 = {
      strAlm_OrigenNombre: 'Total',
      strAlm_destinoNombre: '',
      strArticulo:  '',
      strOpcion: '', 
      strUnidad:'',
      dblCantidad: '',
      dblVolumen:  '',
      dblPeso:  '' 
    };
    array.push(obj3) */
  
  
  
  console.log(array)
  let columns = ['Origen','No. Origen','D','No. Destino','Destino','Articulo' ,'Opcion' ,'Unidad','Cantidad','Volumen'];/* ,'Peso' */
    this._excelService.exportASExcelFile('Transitos Generados', '',columns , array,[], 'TransitosGenerados', 'Transitos');
  
  }
  
}
